<template>
  <div class="posts">
    <belongsList ref="list"></belongsList>
    <router-view @list-reload="listReload" />
  </div>
</template>

<script>
import belongsList from './belongsList.vue'

export default {
  components: {
    belongsList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.posts {
  height: 100%;
  overflow-wrap: anywhere;
}
</style>



// WEBPACK FOOTER //
// src/components/belongs/belongs.vue